import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class ServiceTaskPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:ServiceTask';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'serviceTask',
        label: i18n.serviceTask || 'Service Task',
        entries: [
          {
            id: 'implementation',
            component: () => (
              <TextFieldEntry
                id="epx-implementation"
                label={i18n.implementation || 'Implementation'}
                value={props.implementation || ''}
                onChange={(val) => update('implementation', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
